import classNames from 'classnames';
import useIsMobileDevice from 'hooks/UseIsMobileDevice';
import React, { ReactNode } from 'react';

interface Props {
  htmlFor?: string;
  className?: string;
  children: ReactNode;
}

export default function FormLabel({ children, htmlFor, className }: Props): JSX.Element {
  const isMobileDevice = useIsMobileDevice();

  return (
    <label
      className={classNames('block mb-2 font-medium dark:text-gray-200 text-gray-700', className, {
        'text-sm': !isMobileDevice,
        'text-base': isMobileDevice,
      })}
      htmlFor={htmlFor}
    >
      {children}
    </label>
  );
}
